var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrackPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 370,
    height: 370,
    viewBox: "0 0 370 370",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "track-placeholder-a",
    width: 370,
    height: 370
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#464646",
    xlinkHref: "#track-placeholder-a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    fillRule: "nonzero",
    d: "M186.022867,212.565881 L186.022867,109.714339 C186.022867,105.798561 190.52654,103.595887 193.617468,105.999942 C193.47069,105.885782 200.310474,111.118216 202.340398,112.747864 C219.375367,126.423751 227.70127,140.419362 227.70127,163.492923 C227.70127,166.091768 225.594489,168.198549 222.995644,168.198549 C220.396798,168.198549 218.290018,166.091768 218.290018,163.492923 C218.290018,143.63253 211.444708,132.125755 196.448658,120.086738 C196.188665,119.878013 195.840968,119.603519 195.434119,119.284924 L195.434119,217.271507 L195.434119,238.78294 C195.434119,253.262223 183.696342,265 169.21706,265 C154.737777,265 143,253.262223 143,238.78294 C143,224.303658 154.737777,212.565881 169.21706,212.565881 L186.022867,212.565881 Z",
    opacity: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackPlaceholder);
export default __webpack_public_path__ + "static/media/track-placeholder.4b311dcab036524e6f63594eca515eda.svg";
export { ForwardRef as ReactComponent };